// extracted by css-extract-rspack-plugin
export default {"menuIconButton":"workflow-menu-module__menuIconButton__rKeAi","actionMenuOverlay":"workflow-menu-module__actionMenuOverlay__eiD5k"};